
import builderIoService from '~/composables/builderIoService';
import { CONTENT_TYPES } from '~~/shared/utils/contentTypes'
import type { MarketingAd } from '~~/shared/types/common'

export const useMarketing = () => {

const service = builderIoService(); 

const { data, error, pending, refresh } = useAsyncData<MarketingAd[]>(
  `marketing-${Date.now()}`,
  async () => {
    const fetchOptions: any = {
      fields: 'data.name,data.title,data.description,data.entityType,data.status,data.countryWhitelist,data.countryBlacklist,data.actionButtonUrl,data.actionButtonLabel,data.backgroundImage'
    }
    const result = await service.fetchManyModels(CONTENT_TYPES.MARKETINGAD, '/', false, fetchOptions)
    return result as MarketingAd[]
  },
  {
    server: true,
    lazy: false,
    default: () => [],
    watch: []
  }
)
  return { data, error, pending, refresh };
};
